module.exports = __webpack_public_path__ + "img/logo.9e433f18.png";